export const content = {
	title: 'Контакты',
	address: '127083, г. Москва, вн.тер.г. Муниципальный округ Савеловский, ул. 8 Марта, д. 10, стр. 6',
	phone: '8 900 000-00-00',
	email: 'info@info.ru',
	companyName: 'ООО «МедТех ИИ»',
	inn: 'ИНН: 9713011675',
	ogrn: 'ОГРН: 1247700169342',
}